import React, { useState } from "react";
import { agent } from "../agent";
import * as firebase from "../firebase";
import { Redirect, useHistory } from "react-router-dom";
import { URL_PATHS } from "../routes";
import VerifyCodePage from "../pages/VerifyCode";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../store";
import { myDataActions } from "../store/myData";
import { smartAlert } from "../lib/confirm-alert";

const VerifyCodeContainer = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [code, setCode] = useState("");
    const email = useSelector((state: AppState) => state.myData.auth.email);
    const shouldRegister = useSelector(
        (state: AppState) => state.myData.shouldRegister
    );
    const isJustLoggedIn = useSelector(
        (state: AppState) => state.myData.isJustLoggedIn
    );
    const dispatch = useDispatch();
    const history = useHistory();

    async function onVerifyCode(code: string) {
        setIsLoading(true);
        try {
            const res = await agent.postAuthCode({
                email,
                code
            });
            await firebase.loginUser(res.authToken);
            setIsLoading(false);
            dispatch(myDataActions.myDataShouldLoadSet(true));
        } catch (e) {
            setIsLoading(false);
            setCode("");
            await smartAlert("コード認証に失敗しました。");
        }
    }
    const goBack = () => {
        history.goBack();
    };
    const onCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // 半角数字へ変更
        const code = e.target.value.replace(/[０-９]/g, (s) =>
            String.fromCharCode(s.charCodeAt(0) - 0xfee0)
        );
        setCode(code);
        if (code.length === 6) {
            onVerifyCode(code).then();
            e.target.value = "";
            return;
        }
    };
    if (!email) {
        return <Redirect to={URL_PATHS.login()} />;
    }
    if (isJustLoggedIn) {
        if (shouldRegister) {
            return <Redirect to={URL_PATHS.registerPaid()} />;
        } else {
            return <Redirect to={URL_PATHS.root()} />;
        }
    }
    return (
        <VerifyCodePage
            onVerifyCode={onVerifyCode}
            isLoading={isLoading}
            goBack={goBack}
            onCodeChange={onCodeChange}
            code={code}
        />
    );
};

export default VerifyCodeContainer;
